document.addEventListener('DOMContentLoaded', () => {
  const sucess = document.querySelector('.form-status__message--success');
  const error = document.querySelector('.form-status__liquid-error');
  // const inputsWrapper = document.querySelector('.contact-form__inputs-wrapper.contact-form__active-status-info');
  /**
   * @param {HTMLElement} statusNode status element
   * @param updateURL
   */
  function formSuccess(statusNode, updateURL = false) {
    setTimeout(() => {
      statusNode.remove();
      if (updateURL) {
        window.history.replaceState(null, '', window.location.pathname);
      }
    }, 5000);
  }
  if (sucess) {
    formSuccess(sucess, true);
  } else if (error) {
    formSuccess(error);
  }
});
